import {SectionItem} from 'common/components/items-menu/types';
import {DisplaySize, Placement} from 'common/components/tooltip/types';

import {CountType, FunnelOrder} from './types';

export const SEGMENT_SEPARATOR = ` / `;
export const OVERALL_PROP = `$overall`;
export const OVERALL_PROP_NAME = `Overall`;

const CONVERSION_HELP_LINK = `\n[Learn more](https://help.mixpanel.com/hc/en-us/articles/360029190092-Conversion-Criteria-in-Funnels#unique-users-total-conversions-and-sessions)`;
const commonTooltipAttrs = {size: DisplaySize.Small};

export const COUNT_TYPE_OPTIONS: SectionItem[] = [
  {
    label: `Uniques`,
    value: CountType.Unique,
    tooltip: {text: `Count a single entry per user.${CONVERSION_HELP_LINK}`, ...commonTooltipAttrs},
  },
  {
    label: `Totals`,
    value: CountType.General,
    tooltip: {
      text: `Count multiple entries per user. User may re-enter after converting or dropping off.${CONVERSION_HELP_LINK}`,
      ...commonTooltipAttrs,
    },
  },
  {
    label: `Sessions`,
    value: CountType.Session,
    tooltip: {
      text: `Count the number of sessions that convert within a single session.${CONVERSION_HELP_LINK}`,
      ...commonTooltipAttrs,
    },
  },
];

export const ORDER_OPTIONS: SectionItem[] = [
  {
    label: `specific order`,
    value: FunnelOrder.Loose,
    tooltip: {
      text: `Users must complete the funnel in step order to convert.${CONVERSION_HELP_LINK}`,
      ...commonTooltipAttrs,
    },
  },
  {
    label: `any order`,
    value: FunnelOrder.Any,
    tooltip: {
      text: `Users can complete unanchored funnels steps in any order to convert.${CONVERSION_HELP_LINK}`,
      ...commonTooltipAttrs,
    },
  },
];

export const CONVERSION_WINDOW_TOOLTIP = {
  text: `The time window a user has to complete a funnel from the time they enter.${CONVERSION_HELP_LINK}`,
  ...commonTooltipAttrs,
};

export const HOLD_PROPERTY_CONSTANT_TOOLTIP = {
  text: `A property that must retain a single value across all funnels steps for a user to convert through the funnel.`,
  placement: Placement.Right,
  ...commonTooltipAttrs,
};

export const EXCLUSION_EVENTS_TOOLTIP = {
  text: `Exclude users in between steps who performed exclusion events.`,
  placement: Placement.Right,
  ...commonTooltipAttrs,
};
